// extracted by mini-css-extract-plugin
export default {"normList__spacer":"NormList_normList__spacer__bOQvZ","normList__searchResult":"NormList_normList__searchResult__zUGPr"};